import { baseStoreCreator } from '@/utils/store';

export interface PlanOrganizationPathPayload {
  organizationPath?: string;
}

export const DEFAULT_VALUES: PlanOrganizationPathPayload = {
  organizationPath: undefined,
};

const usePlanOrganizationPathStore = baseStoreCreator<PlanOrganizationPathPayload>(DEFAULT_VALUES);

export default usePlanOrganizationPathStore;
